<template>
  <div v-for="(d, index) in <Damage[]>damage" :key="`damage-${index}`" class="text-center d-inline-block">
    <v-tooltip max-width="600">
      <template #activator="{ props }">
        <span v-if="small" v-bind="props">
          <v-icon :color="damageColor(d)" :icon="damageIcon(d)" />
          <v-icon v-if="d.Override" icon="mdi-information-outline" color="text" />
          <b v-else v-text="`${added ? '+' : ''}${displayValue(d.Value)}`" />
        </span>
        <v-row v-else align="center" no-gutters v-bind="props">
          <v-col cols="auto">
            <v-icon :size="dense ? 25 : 35" :color="damageColor(d)" :icon="damageIcon(d)" />
          </v-col>
          <v-col class="heading" :style="`font-size: ${dense ? '20' : '24'}pt`">
            {{ `${added ? '+' : ''}${displayValue(d.Value)}` }}
          </v-col>
        </v-row>
      </template>
      <div class="heading h3">{{ displayValue(d.Value) }} {{ typeOverride || d.Type }} Damage</div>
      <v-divider class="my-2" />
      <div v-html-safe="gloss(d)" />
    </v-tooltip>
    <div v-if="!small" class="text-cc-overline mt-n1">
      {{ typeOverride ? typeOverride : d.Type }}
    </div>
  </div>
</template>

<script lang="ts">
import { Damage } from '@/class';

export default {
  name: 'cc-damage-element',
  props: {
    damage: {
      type: Array,
      required: true,
    },
    typeOverride: {
      type: String,
      required: false,
    },
    small: {
      type: Boolean,
    },
    added: {
      type: Boolean,
    },
    inline: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
  },
  data: () => ({
    dialog: false,
    availableTypes: [],
    selected: '',
  }),
  methods: {
    damageColor(d: Damage): string {
      return this.typeOverride ? `damage--${this.typeOverride.toLowerCase()}` : d.Color;
    },
    damageIcon(d: Damage): string {
      return this.typeOverride ? `cc:${this.typeOverride.toLowerCase()}` : d.Icon;
    },
    gloss(d: Damage): string {
      switch (d.Type.toLowerCase()) {
        case 'heat':
          return `This equipment deals ${d.Value} ${d.Type} Damage<br><div class="text-overline text-disabled mb-n2 ">HEAT:</div>Heat is a special type of harm that doesn’t count as damage and ignores ARMOR, although it can be affected by RESISTANCE. It represents damage to a mech's internal systems and reactor. It's most often inflicted by electronic warfare, but is often generated by a mech’s own systems. When a mech reaches its HEAT CAP, any additional Heat causes it to overheat. If a character without a HEAT CAP (such as BIOLOGICAL characters and some DRONES) would take Heat, they instead take an equivalent amount of Energy damage.`;
        case 'burn':
          return `This equipment deals ${d.Value} ${d.Type} Damage<br><div class="text-overline text-disabled mb-n2 ">BURN:</div>Some weapons deal Burn (damage over time). Burn might represent flames, searing plasma, acid or something more insidious, like a swarm of greywash nanites. When characters take Burn, it has two effects: first, they immediately take Burn damage, ignoring ARMOR, and then they record Burn they just took. At the end of their turn, characters with Burn marked must roll an ENGINEERING check. On a success, they clear all burn currently marked; otherwise, they take Burn damage equal to the amount of Burn currently marked. Burn from additional sources adds to the total marked Burn.`;
        default:
          return `This equipment deals ${d.Value} ${d.Type} Damage`;
      }
    },
    displayValue(value: number | string | number[] | string[]): string {
      if (Array.isArray(value)) {
        return value.join(' / ');
      }
      return value.toString();
    },
  },
};
</script>
